import type { LogEntry, Middleware, MiddlewareNext } from '../types'


// this middleware extract cause to extra attributes
function causeMiddleware(): Middleware {
  return (entry: LogEntry, next: MiddlewareNext) => {
    const { message, extra } = entry

    if (message instanceof Error) {
      // @ts-ignore
      const cause = message.hasOwnProperty('cause') ? message.cause : null

      if (cause) {
        const newEntry = {
          ...entry,
          extra: {
            ...extra,
            cause,
          },
        }

        next(newEntry)
        return
      }
    }

    next(entry)
  }
}


export default causeMiddleware
